/** Cartesia sonic-3 emotion tags (English). Empty / auto = model interprets transcript. */
export const TTS_EMOTION_PRIMARY = [
  "neutral",
  "calm",
  "angry",
  "content",
  "sad",
  "scared",
] as const;

export const TTS_EMOTION_MORE = [
  "happy",
  "excited",
  "enthusiastic",
  "elated",
  "curious",
  "peaceful",
  "serene",
  "grateful",
  "affectionate",
  "sympathetic",
  "mysterious",
  "frustrated",
  "agitated",
  "disappointed",
  "melancholic",
  "anxious",
  "confident",
  "proud",
  "skeptical",
  "contemplative",
  "determined",
  "apologetic",
  "hesitant",
  "surprised",
  "amazed",
] as const;

export const TTS_GENDER_OPTS = [
  { value: "", label: "All genders" },
  { value: "feminine", label: "Feminine" },
  { value: "masculine", label: "Masculine" },
  { value: "gender_neutral", label: "Neutral" },
] as const;

export const TTS_LANGUAGE_OPTS = [
  { value: "", label: "All languages" },
  { value: "en", label: "English" },
  { value: "en-US", label: "English (US)" },
  { value: "en-GB", label: "English (UK)" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "pt", label: "Portuguese" },
  { value: "it", label: "Italian" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "zh", label: "Chinese" },
  { value: "hi", label: "Hindi" },
  { value: "ar", label: "Arabic" },
] as const;

export type VoiceDeliveryValue = {
  voiceId: string | null;
  voiceName?: string | null;
  ttsSpeed?: number | null;
  ttsVolume?: number | null;
  ttsEmotion?: string | null;
};

export function clampTtsSpeed(v: unknown, fallback = 1): number {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  return Math.round(Math.max(0.6, Math.min(1.5, n)) * 100) / 100;
}

export function clampTtsVolume(v: unknown, fallback = 1): number {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  return Math.round(Math.max(0.5, Math.min(2, n)) * 100) / 100;
}

export function genderLabel(g: string | null | undefined): string {
  if (g === "feminine") return "Feminine";
  if (g === "masculine") return "Masculine";
  if (g === "gender_neutral") return "Neutral";
  return "—";
}
